import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import GuideLayout from './GuideLayout';
import Contact from '../Contact/Contact';

// Poradnik pod frazy wyszukiwane przez właścicieli zakładów: „marketing zakładu pogrzebowego”,
// „reklama zakładu pogrzebowego”, „strona internetowa zakładu pogrzebowego”, „zakład pogrzebowy Facebook”.
// Na dole formularz kontaktowy z ofertą stron wizytówkowych.

// Celowo tylko „co”, bez „jak” - szczegóły to wiedza, którą oferujemy przy współpracy
const CHANNELS = [
    { title: 'Profil Firmy w Google', text: 'Pierwsze, co widzi rodzina po wpisaniu „zakład pogrzebowy” i nazwy miejscowości.' },
    { title: 'Strona internetowa', text: 'Buduje wiarygodność i przekonuje, żeby zadzwonić właśnie do Ciebie.' },
    { title: 'Opinie klientów', text: 'Rodziny wybierają pod presją czasu i ufają temu, co piszą inni.' },
    { title: 'Facebook', text: 'Lokalna społeczność obserwuje zakłady, które publikują nekrologi.' },
    { title: 'Współpraca lokalna', text: 'Parafie, hospicja i kwiaciarnie potrafią przynieść więcej zleceń niż reklamy.' },
    { title: 'Spójny wygląd materiałów', text: 'Nekrologi i tabliczki z nazwą zakładu to reklama przy każdym pogrzebie.' },
];

const GOOGLE_STEPS = [
    {
        title: 'Załóż lub przejmij wizytówkę',
        text: 'Wejdź na stronę Profilu Firmy w Google i wyszukaj swój zakład - często wizytówka już istnieje i wystarczy ją zweryfikować.',
    },
    {
        title: 'Uzupełnij wszystkie dane',
        text: 'Kategoria „Zakład pogrzebowy”, telefon (najlepiej całodobowy), adres, godziny otwarcia, obszar działania i link do strony internetowej.',
    },
    {
        title: 'Dodaj prawdziwe zdjęcia',
        text: 'Budynek z zewnątrz, biuro, sala pożegnań, karawan, zespół. Zdjęcia stockowe budzą nieufność - autentyczne budują zaufanie.',
    },
    {
        title: 'Proś o opinie i odpowiadaj na nie',
        text: 'Delikatnie, kilka tygodni po pogrzebie - np. na wizytówce lub w wiadomości z podziękowaniem. Odpowiadaj na każdą opinię, także krytyczną, spokojnie i z szacunkiem.',
    },
    {
        title: 'Aktualizuj na bieżąco',
        text: 'Zmiana godzin w święta, nowe usługi, nowe zdjęcia. Aktywny profil Google chętniej pokazuje wyżej.',
    },
];

const WEBSITE_CHECKLIST = [
    { title: 'Telefon widoczny od razu', text: 'Duży numer na górze strony, który na telefonie dzwoni po jednym dotknięciu. Najlepiej z informacją, że działa całą dobę.' },
    { title: 'Działa dobrze na telefonie', text: 'Większość rodzin szuka zakładu na smartfonie - często w szpitalu albo w drodze. Strona musi szybko się ładować i być czytelna.' },
    { title: 'Co zrobić, gdy ktoś umrze', text: 'Krótka instrukcja krok po kroku: akt zgonu, zasiłek pogrzebowy, kontakt z parafią. Pomaga rodzinie i pokazuje Twoje doświadczenie.' },
    { title: 'Oferta i zakres usług', text: 'Organizacja pogrzebu, kremacja, transport, oprawa, kwiaty, nekrologi i tabliczki. Jasno, bez marketingowego języka.' },
    { title: 'Adres, mapa i dojazd', text: 'Mapa Google z lokalizacją biura i - jeśli masz - domu pogrzebowego. Godziny otwarcia i parking.' },
    { title: 'Zdjęcia i zespół', text: 'Prawdziwe zdjęcia miejsca i ludzi. Rodzina chce wiedzieć, komu powierza ostatnie pożegnanie bliskiej osoby.' },
];

const ETHICS = [
    { title: 'Bez nachalności', text: 'Żadnych agresywnych promocji, „okazji” i liczników czasu. W tej branży liczy się spokój, szacunek i zaufanie.' },
    { title: 'Zgoda rodziny na publikację', text: 'Nekrolog na Facebooku publikuj tylko za zgodą bliskich. Zapytaj też o zdjęcie i o to, czy podać godzinę pogrzebu.' },
    { title: 'Przejrzyste ceny', text: 'Choćby orientacyjne widełki cen podstawowych usług. Rodziny doceniają, że nie muszą o nie pytać w trudnym momencie.' },
    { title: 'Szybka odpowiedź', text: 'Telefon i wiadomości odbierane od razu - także wieczorem i w weekend. To najskuteczniejszy „marketing” zakładu pogrzebowego.' },
];

const CONTACT_POINTS = [
    { title: 'Strona wizytówkowa dla zakładu', text: 'Prosta, elegancka strona z ofertą, telefonem, mapą dojazdu i zdjęciami - dopasowana do telefonów.' },
    { title: 'Widoczność w Google', text: 'Strona przygotowana pod wyszukiwanie „zakład pogrzebowy” w Twojej miejscowości i połączona z wizytówką Google.' },
    { title: 'Spójnie z materiałami', text: 'W tym samym stylu co nekrologi, klepsydry i tabliczki z Nekrodruku - z nazwą i logo Twojego zakładu.' },
];

const FAQ = [
    {
        question: 'Jak zareklamować zakład pogrzebowy?',
        answer: 'Najskuteczniejsze są: uzupełniony Profil Firmy w Google z opiniami, prosta strona internetowa z widocznym telefonem, aktywny profil na Facebooku z nekrologami (za zgodą rodzin) oraz dobre relacje z parafiami, hospicjami i kwiaciarniami. W tej branży ważniejsze od reklam jest zaufanie.',
    },
    {
        question: 'Czy zakład pogrzebowy potrzebuje strony internetowej?',
        answer: 'Tak. Rodziny szukają zakładu w Google, a strona z ofertą, telefonem i zdjęciami buduje wiarygodność, której nie da sama wizytówka. Wystarczy prosta strona wizytówkowa - nie potrzeba rozbudowanego serwisu.',
    },
    {
        question: 'Czy można publikować nekrologi na Facebooku zakładu?',
        answer: 'Tak, ale zawsze za zgodą rodziny. Ustal, czy można podać zdjęcie oraz datę i godzinę pogrzebu. Nekrolog przygotowany w Nekrodruku pobierzesz jako obraz JPG gotowy do publikacji.',
    },
    {
        question: 'Jak zdobyć opinie w Google dla zakładu pogrzebowego?',
        answer: 'Poproś delikatnie, z wyczuciem i z pewnym odstępem od pogrzebu - np. kodem QR na wizytówce lub w wiadomości z podziękowaniem. Nigdy nie kupuj opinii i odpowiadaj na każdą, także krytyczną.',
    },
    {
        question: 'Czy robicie strony internetowe dla zakładów pogrzebowych?',
        answer: 'Tak. Oprócz programu Nekrodruk przygotowujemy strony wizytówkowe dla zakładów pogrzebowych. Napisz do nas przez formularz na dole strony - odpowiemy w ciągu jednego dnia roboczego.',
    },
];

export default function MarketingZakladu() {
    return (
        <GuideLayout
            path='/marketing-zakladu-pogrzebowego'
            title='Marketing zakładu pogrzebowego - jak zdobywać klientów w internecie | Nekrodruk.pl'
            description='Jak reklamować zakład pogrzebowy? Profil Firmy w Google, strona internetowa, opinie, Facebook i współpraca lokalna - praktyczny poradnik dla właścicieli zakładów pogrzebowych. Przygotowujemy też strony wizytówkowe dla zakładów.'
            keywords='marketing zakładu pogrzebowego, reklama zakładu pogrzebowego, strona internetowa zakładu pogrzebowego, strona wizytówkowa zakład pogrzebowy, zakład pogrzebowy Facebook, wizytówka Google zakład pogrzebowy, jak zdobyć klientów zakład pogrzebowy'
            heading={<>Marketing zakładu pogrzebowego<em> - jak rodziny znajdują Cię w internecie</em></>}
            lead='Coraz więcej rodzin szuka zakładu pogrzebowego w telefonie - w szpitalu, w nocy, pod presją czasu. Podpowiadamy, jak sprawić, żeby znalazły właśnie Ciebie: od wizytówki Google, przez stronę internetową, po Facebooka - z wyczuciem, jakiego wymaga ta branża.'
            actions={
                <>
                    <HashLink smooth to='/marketing-zakladu-pogrzebowego#Contact' className='guide_btn guide_btn--light'>
                        Zamów stronę wizytówkową
                    </HashLink>
                    <HashLink smooth to='/marketing-zakladu-pogrzebowego#kanaly' className='guide_btn guide_btn--ghost'>
                        Czytaj poradnik
                    </HashLink>
                </>
            }
            faq={FAQ}
            contact={
                <Contact
                    title={<>Potrzebujesz strony<em> dla swojego zakładu?</em></>}
                    lead='Oferujemy także strony wizytówkowe dla zakładów pogrzebowych. Napisz, czego potrzebujesz - odpowiemy najpóźniej w ciągu jednego dnia roboczego.'
                    points={CONTACT_POINTS}
                    defaultSubject='Strona wizytówkowa dla zakładu pogrzebowego'
                />
            }
        >
            <section className='guide_section' id='kanaly'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Gdzie szukają rodziny</span>
                    <h2 className='guide_title'>6 kanałów, które przyprowadzają klientów</h2>
                    <p className='guide_lead'>
                        Zakład pogrzebowy wybiera się rzadko, szybko i w emocjach. Rodzina dzwoni zwykle do pierwszej firmy,
                        która wzbudzi zaufanie - dlatego liczy się to, co zobaczy w pierwszych minutach szukania.
                    </p>
                    <div className='guide_cards'>
                        {CHANNELS.map((channel) => (
                            <article key={channel.title} className='guide_card'>
                                <h3>{channel.title}</h3>
                                <p>{channel.text}</p>
                            </article>
                        ))}
                    </div>
                    <p className='guide_note'>
                        Jak wykorzystać te kanały w Twojej miejscowości i od czego zacząć?{' '}
                        <HashLink smooth to='/marketing-zakladu-pogrzebowego#Contact'>Napisz do nas</HashLink> - przygotujemy
                        plan dopasowany do Twojego zakładu.
                    </p>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Krok po kroku</span>
                    <h2 className='guide_title'>Wizytówka Google zakładu pogrzebowego</h2>
                    <ol className='guide_steps guide_steps--wide'>
                        {GOOGLE_STEPS.map((step) => (
                            <li key={step.title}>
                                <strong>{step.title}</strong>
                                <span>{step.text}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Strona internetowa</span>
                    <h2 className='guide_title'>Co powinna zawierać strona zakładu pogrzebowego?</h2>
                    <p className='guide_lead'>
                        Nie potrzebujesz rozbudowanego serwisu. Wystarczy prosta strona wizytówkowa, która w kilka sekund
                        odpowie rodzinie na trzy pytania: kim jesteście, co robicie i jak się z wami skontaktować.
                    </p>
                    <ul className='guide_checklist'>
                        {WEBSITE_CHECKLIST.map((item) => (
                            <li key={item.title}>
                                <strong>{item.title}</strong>
                                <span>{item.text}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Facebook</span>
                    <h2 className='guide_title'>Nekrologi na Facebooku - lokalna społeczność wokół zakładu</h2>
                    <p className='guide_lead'>
                        W mniejszych miejscowościach mieszkańcy obserwują stronę zakładu pogrzebowego, żeby wiedzieć, kto
                        zmarł i kiedy jest pogrzeb. Regularnie publikowane nekrologi - zawsze za zgodą rodziny - sprawiają,
                        że nazwa Twojego zakładu jest dobrze znana w okolicy.
                    </p>
                    <p className='guide_note'>
                        Nekrolog przygotowany w Nekrodruku pobierzesz jako obraz JPG gotowy do publikacji - z tych samych
                        danych powstaje klepsydra do druku, tabliczka i szarfa. Zobacz też, co powinien zawierać{' '}
                        <Link to='/co-to-nekrolog'>poprawny nekrolog</Link>.
                    </p>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Z wyczuciem</span>
                    <h2 className='guide_title'>Etyka w marketingu zakładu pogrzebowego</h2>
                    <ul className='guide_checklist'>
                        {ETHICS.map((item) => (
                            <li key={item.title}>
                                <strong>{item.title}</strong>
                                <span>{item.text}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <div className='guide_callout'>
                        <div>
                            <h2>
                                Strona wizytówkowa<em> dla Twojego zakładu pogrzebowego</em>
                            </h2>
                            <p>
                                Oprócz programu do nekrologów, tabliczek i szarf przygotowujemy także strony wizytówkowe dla
                                zakładów pogrzebowych - proste, eleganckie i czytelne na telefonie. Dbamy również o to, aby
                                Twoja firma pokazywała się jako pierwsza w wyszukiwarce, gdy ktoś w okolicy szuka zakładu
                                pogrzebowego. Napisz, a przygotujemy propozycję.
                            </p>
                        </div>
                        <div className='guide_actions'>
                            <HashLink smooth to='/marketing-zakladu-pogrzebowego#Contact' className='guide_btn guide_btn--light'>
                                Napisz do nas
                            </HashLink>
                            <Link to='/register' className='guide_btn guide_btn--ghost'>
                                Wypróbuj Nekrodruk
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </GuideLayout>
    );
}
